function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M30.75 3.826c-.51.276-2.039.833-3.463.973.912-.487 2.266-2.086 2.6-3.36-.878.556-2.898 1.37-3.893 1.37l.002.004A6.252 6.252 0 0 0 21.484.9c-3.448 0-6.241 2.767-6.241 6.18 0 .477.054.934.16 1.378H15.4C10.723 8.339 4.43 7.03 1.35 3.06c-1.89 3.247-.252 6.46 1.894 7.773-.735.056-2.087-.081-2.725-.696-.044 2.152 1.001 5.005 4.812 6.037-.733.394-2.03.283-2.597.195.2 1.82 3.951 4.198 6.762 4.198-1.004 1.146-4.773 3.226-9 2.566a18.881 18.881 0 0 0 9.761 2.732c10.072 0 17.892-8.704 17.47-18.675l-.003-.03c0-.029.003-.055.003-.081 0-.03-.003-.06-.003-.092.917-.62 2.144-1.717 3.026-3.161"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.9298fd4c.svg";
export { ForwardRef as ReactComponent };